export default "__VITE_ASSET__BR8Qnghd__"